import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-display-pdf',
    templateUrl: './display-pdf.component.html',
    styleUrls: ['./display-pdf.component.scss'],
    standalone: false
})
export class DisplayPdfComponent implements AfterViewInit {
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;
  @ViewChild('pdfViewerAutoLoad') pdfViewerAutoLoad;

  receipt: any;

  constructor(
    private dialogRef: MatDialogRef<DisplayPdfComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.receipt = data.receipt;
  }

  ngAfterViewInit(): void {
    this.pdfViewerOnDemand.pdfSrc = this.receipt;
    this.pdfViewerOnDemand.refresh();
  }
}
